import { type FormEvent, useEffect, useId, useState } from "react"

import { ErrorApi } from "@/api/cliente"
import { Boton } from "@/componentes/ui/Boton"
import { Modal } from "@/componentes/ui/Modal"

/**
 * La contraseña del SISTEMA, para abrir el cofre cinco minutos.
 *
 * ⚠ **Es la tuya, no la de la credencial.** Lo que se comprueba es que quien está
 * delante del equipo es quien abrió la sesión; la del portal sale después. Con la
 * sesión abierta doce horas, un equipo desatendido revelaría el cofre entero sin esto.
 */
export function PedirClave({
  abierto,
  error,
  pendiente,
  onEnviar,
  onCerrar,
}: {
  abierto: boolean
  error: Error | null
  pendiente: boolean
  onEnviar: (password: string) => void
  onCerrar: () => void
}) {
  const id = useId()
  const [clave, setClave] = useState("")

  // Al cerrarse se olvida lo tecleado: la próxima vez empieza vacío.
  useEffect(() => {
    if (!abierto) setClave("")
  }, [abierto])

  function enviar(evento: FormEvent) {
    evento.preventDefault()
    if (clave !== "") onEnviar(clave)
  }

  const mensaje =
    error instanceof ErrorApi && error.detalles?.motivo !== "COFRE_CERRADO" ? texto(error) : null

  return (
    <Modal
      abierto={abierto}
      titulo="Abrir el cofre"
      descripcion="Escribe tu contraseña del sistema. El cofre queda abierto 5 minutos en esta sesión y no se vuelve a pedir."
      onCerrar={onCerrar}
      ancho="sm"
    >
      <form onSubmit={enviar}>
        <label htmlFor={`${id}-clave`} className="mb-1 block text-xs font-medium uppercase">
          Tu contraseña
        </label>
        <input
          id={`${id}-clave`}
          type="password"
          autoComplete="current-password"
          value={clave}
          onChange={(e) => setClave(e.target.value)}
          className="campo"
        />
        {mensaje !== null && (
          <p role="alert" className="mt-2 text-sm" style={{ color: "var(--destructive)" }}>
            {mensaje}
          </p>
        )}
        <div className="mt-4 flex justify-end gap-2">
          <Boton variante="fantasma" onClick={onCerrar}>
            Cancelar
          </Boton>
          <Boton variante="primario" type="submit" disabled={clave === "" || pendiente}>
            {pendiente ? "Comprobando…" : "Abrir"}
          </Boton>
        </div>
      </form>
    </Modal>
  )
}

function texto(error: ErrorApi): string {
  const restantes = error.detalles?.restantes
  if (error.detalles?.motivo === "CLAVE_INCORRECTA" && typeof restantes === "number") {
    return `La contraseña no es correcta. Te quedan ${restantes} intento${restantes === 1 ? "" : "s"}.`
  }
  return error.message
}
